'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    // ссылки, выделенный текст, активные состояния
    tAccent: '#8BC34A',
    // предупреждение
    tWarning: '#F5A623',
    // цвет ошибки
    tError: '#FF635F',
    // цвет текста в активном состоянии
    tActive: 'rgba(0, 0, 0, 1)',
    // цвет заполненного неактивного текста
    tFilled: 'rgba(0, 0, 0, 0.87)',
    // второстепенный цвет текста, цвет неактивных иконок
    tInactive: 'rgba(0, 0, 0, 0.54)',
    // цвет label
    tLabel: 'rgba(0, 0, 0, 0.54)',
    // цвет подсказок
    tHint: 'rgba(0, 0, 0, 0.38)',
    // placeholder
    tPlaceholder: 'rgba(0, 0, 0, 0.24)',
    // disabled
    tDisabled: 'rgba(0, 0, 0, 0.24)',
    tInversion: '#FFFFFF',

    // Основной фирменный цвет
    elAccent: '#00D352',
    // Темное состояние основного цвета для hover эффектов на кнопках, Цвет текстовых ссылок и выделенного текста
    elAccentDark: '#69af25',
    // Светлое состояние основного цвета для pass эффектов на кнопках. Hover цвет для текстовых ссылок
    elAccentLight: '#aee571',
    // фирменный второстепенный, активные состояния
    elSecondaryAccent: '#61b1e7',
    elSecondaryAccentDark: '#217cb5',
    elSecondaryAccentLight: '#97d4ff',
    // фирменный красный
    elError: '#FF635F',
    // фон для ошибки
    elErrorLight: '#ffe6e5',
    // фирменный второстепенный
    elWarning: '#F5A623',
    // основной фон
    elPrimary: '#FFFFFF',
    // hover для светлых фонов
    elPrimaryLight: 'rgba(0, 0, 0, 0.02)',
    // самый светлый фон
    elLightest: 'rgba(0, 0, 0, 0.04)',
    // светлый фон
    elLight: 'rgba(0, 0, 0, 0.08)',
    // темный фон
    elDivider: 'rgba(0, 0, 0, 0.12)',
    // самый темный фон
    elDarkest: 'rgba(0, 0, 0, 0.24)',
    // черный фон (для темной темы)
    elBlack: 'rgba(0, 0, 0, 0.87)',

    // темный фон
    elSecondaryLight: 'rgba(13, 12, 34, 0.1)',
    elSecondary: 'rgba(0, 0, 0, 0.54)',

    // тени
    elShadowMain: 'rgba(0, 0, 0, 0.24)',
    elShadow: 'rgba(0, 0, 0, 0.16)',
    // TODO REMOVE
    elShadowLight: 'rgba(0, 0, 0, 0.16)',

    // text
    fontFamily: 'Open Sans',

    // font weight
    twNormal: 400,
    // light
    twLight: 300,
    // bold
    twBold: 700,
    // semi-bold
    twSemi: 600,

    tsXXSmall: '10px',
    tsXSmall: '12px',
    tsSmall: '14px',
    tsNormal: '16px',
    tsLarge: '20px',
    tsXLarge: '22px',
    tsXXLarge: '24px',

    tlXXSmall: '10px',
    tlXSmall: '20px',
    tlSmall: '22px',
    tlNormal: '24px',
    tlLarge: '28px',
    tlXLarge: '30px',
    tlXXLarge: '32px',

    // gutter width
    gutter: 8,

    transitionDuration: '450ms',

    transitionDurationNumber: 450,

    transitionFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',

    transitionDelay: '0ms',

    mainTransition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1)',

    zMaximal: 1001,
    zOverlay: 999
};